import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import {
  toggleNavigation,
} from '@xanadu/ui-shared/modules/navigation/actions';

import Header from '../../../components/header/Header';

import {
  triggerUpdateRightSidebar,
} from '../../../modules/rightSidebar/actions';

import {
  changeProduct
} from '@xanadu/ui-shared/modules/application/actions';


const mapDispatchToProps = {
  changeProduct,
  updateRightSidebar: triggerUpdateRightSidebar,
  toggleNavigation,
};

function mapStateToProps(state) {
  return {
    product: state.getIn(['application', 'product']),
    isLoggedIn: state.getIn(['user', 'isLoggedIn']),
    casinoVisibilityRestricted: state.getIn(['vegas', 'visibilityRestricted']),
    cinemaMode: state.getIn(['application', 'cinemaMode']),
    virtualsAllowed: state.getIn(['user', 'virtualsAllowed']),
    widthSize: state.getIn(['application', 'widthSize']),
    sidebarContent: state.getIn(['rightSidebar', 'content']),
    storedAccountID: state.getIn(['dataLayer', 'accountID'])
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));
